import {combineReducers} from 'redux';
import commonReducer from './shared/common/redux/reducer';
import HomepageReducer from './shared/pages/Homepage/redux/reducer';
import SearchpageReducer from './shared/pages/SearchPage/redux/reducer';
import ReviewpageReducer from './shared/pages/ReviewPage/redux/reducer';
import SeoPageReducer from './shared/pages/SeoPage/redux/reducer';
import HOBReducer from './shared/pages/HouseOfBrands/redux/reducer';

const reducerList = {
  common: commonReducer,
  home: HomepageReducer,
  srp: SearchpageReducer,
  review: ReviewpageReducer,
  seoPage: SeoPageReducer,
  hob: HOBReducer
};

export default reducerList;

const rootReducer = combineReducers(reducerList);


export type AppState = ReturnType<typeof rootReducer>;